<template>
    <div class="link-move-item">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'link-move-item'
    };
</script>

<style>
    .link-move-item {
        box-sizing: border-box;
    }
</style>
